import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { PaymentSummary } from '../../models/payment-summary.model';

@Component({
  selector: 'app-floating-submit',
  templateUrl: './floating-submit.component.html',
  styleUrls: ['./floating-submit.component.scss']
})
export class FloatingSubmitComponent implements OnInit {
  @Input() paymentSummary: PaymentSummary;
  @Input() submitReady: boolean;
  @Input() submitted: boolean;
  @Output() formSubmitted = new EventEmitter();
  scrolled: boolean;

  constructor(private element: ElementRef) {}

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    this.scrolled = window.innerHeight - this.element.nativeElement.getBoundingClientRect().bottom > 1;
  }

  ngOnInit(): void {}

  submit() {
    this.formSubmitted.emit();
  }
}
